import { observable, action, runInAction } from 'mobx';
import applyAPI from '../apis/applyAPI'
import alertMessage from '../utils/alertMessage'

export default class ApplyStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  /*get Apply init*/
  @observable applyInit= null
  @action
  async onGetApplyInitAction(){
    this.isFetching = true
    this.applyInit= null
    try {
      const response = await applyAPI.getApplyInitAction()
      runInAction(() => {
        this.isFetching = false;
        if (response?.data?.data?.code === 0) {
          if(response.data.data.data!==null){
            this.applyInit=response.data.data.data
          }
        }else {
          alertMessage.error('Failed！' + response.data.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get Approver list*/
  @observable approverList=[]
  @action
  async onGetApproverAction(){
    this.isFetching = true
    this.approverList=[]
    try {
      const response = await applyAPI.getApproverAction()
      runInAction(() => {
        this.isFetching = false;
        if (response.data.data.code === 0) {
          if(response.data.data.data!==null){
            this.approverList=response.data.data.data
          }else {
            alertMessage.error('Failed！ No data!')
          }
        }else {
          alertMessage.error('Failed！' + response.data.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*submit apply*/
  @action
  async onApplyAction(params){
    this.isFetching = true
    try {
      const response = await applyAPI.applyAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          if (response.data.data.code === 0) {
            alertMessage.success('Apply Success！')
          }else{
            alertMessage.error('Apply Failed！' + response.data.data.messageEn +'')
          }
        }else {
          alertMessage.error('Apply Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
}
